module.exports = __webpack_public_path__ + "img/no-image.683fa6a4.png";